import { render, staticRenderFns } from "./RPixibayPicker.vue?vue&type=template&id=0ada545e&"
import script from "./RPixibayPicker.vue?vue&type=script&lang=js&"
export * from "./RPixibayPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports